import { ApplicationRole } from "./ApplicationRole";
import { BlockModel } from "./BlockModel";
import { CompanyModel } from "./CompanyModel";

/**
 * Represents a user in the system.
 */
export class User {
    /**
     * The unique code of the user.
     */
    User_Code?: number;

    /**
     * The name of the user.
     */
    User_Name?: string;

    /**
     * The CAI (Common Access Identifier) of the user.
     */
    CAI?: string;

    /**
     * The email address of the user.
     */
    Email?: string;

    /**
     * Indicates whether the user is a partner.
     */
    Is_Partner?: boolean;

    /**
     * The company associated with the user.
     */
    Company?: CompanyModel;

    /**
     * The block associated with the user.
     */
    Block?: BlockModel;

    /**
     * The application roles assigned to the user.
     */
    ApplicationRoles?: ApplicationRole[];

    /**
     * The roles of the user as a string.
     */
    Roles?: string;

    /**
     * Indicates whether the user is an RFC (Request for Change) admin.
     */
    IsRFCAdmin?: boolean;

    /**
     * Indicates whether the user is active.
     */
    Active?: boolean;

    /**
     * The departments associated with the user.
     */
    Departments?: number[];

    /**
     * The sub-departments associated with the user.
     */
    SubDepartments?: number[];
    
}
